(function(){
  var pop = document.getElementById('meneaPop');
  if (!pop) return;
  var S = window.MENEA_POP || {};
  var KEY_SUB = 'menea_sub', KEY_CLOSED = 'menea_pop_closed', DAYS = 7;
  function get(k){ try { return localStorage.getItem(k); } catch(e){ return null; } }
  function set(k,v){ try { localStorage.setItem(k, v); } catch(e){} }
  var last = null;
  function open(){
    if (!pop.hidden) return;
    last = document.activeElement;
    pop.hidden = false;
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function(){ pop.classList.add('show'); });
    var f = pop.querySelector('input[type=email], [data-copy]');
    if (f) setTimeout(function(){ f.focus(); }, 50);
    detach();
  }
  function close(){
    pop.classList.remove('show');
    setTimeout(function(){ pop.hidden = true; document.body.style.overflow = ''; if (last && last.focus) last.focus(); }, 250);
    if (!S.ok) set(KEY_CLOSED, String(Date.now()));
  }
  pop.addEventListener('click', function(e){
    if (e.target === pop || e.target.closest('[data-pop-close]')) {
      if (e.target.closest('a[data-pop-close]')) { set(KEY_SUB, '1'); return; }
      close();
    }
    var c = e.target.closest('[data-copy]');
    if (c) {
      var t = c.dataset.copy;
      (navigator.clipboard ? navigator.clipboard.writeText(t) : Promise.reject()).then(function(){ c.textContent = '¡Copiado!'; }).catch(function(){
        var r = document.createRange(); r.selectNodeContents(document.getElementById('popCode'));
        var s = window.getSelection(); s.removeAllRanges(); s.addRange(r);
      });
    }
  });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !pop.hidden) close(); });
  pop.querySelector('form') && pop.querySelector('form').addEventListener('submit', function(){ set(KEY_SUB, '1'); });

  if (S.ok) { set(KEY_SUB, '1'); open(); return; }
  if (S.err) { open(); return; }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:select', function(e){ if (e.target.contains(pop)) open(); });
    document.addEventListener('shopify:section:deselect', function(e){ if (e.target.contains(pop)) close(); });
    return;
  }

  if (get(KEY_SUB)) return;
  var closed = parseInt(get(KEY_CLOSED), 10);
  if (closed && Date.now() - closed < DAYS * 864e5) return;

  var timer, armed = false;
  function onScroll(){
    var h = document.documentElement;
    if ((h.scrollTop + h.clientHeight) / h.scrollHeight > 0.4) open();
  }
  function onLeave(e){ if (e.clientY <= 0 && !e.relatedTarget) open(); }
  function detach(){
    clearTimeout(timer);
    window.removeEventListener('scroll', onScroll);
    document.removeEventListener('mouseout', onLeave);
  }
  function arm(){
    if (armed) return; armed = true;
    timer = setTimeout(open, (parseInt(pop.dataset.delay, 10) || 9) * 1000);
    window.addEventListener('scroll', onScroll, { passive: true });
    if (window.matchMedia('(pointer:fine)').matches) document.addEventListener('mouseout', onLeave);
  }
  var age = document.getElementById('ageGate');
  if (age && age.classList.contains('open')) {
    var yes = document.getElementById('ageYes');
    if (yes) yes.addEventListener('click', function(){ setTimeout(arm, 1500); });
  } else {
    arm();
  }
})();
